import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const MontoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='MONTO' htmlFor='input-monto' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='monto'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-monto'
              placeholder='0.00'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MontoFormGroup)
